export enum VildMappingSize {
  THIN = 3,
  BOLD = 8
}



// WEBPACK FOOTER //
// ./src/app/models/enums/vildmapping-size.ts